<template>
  <div class="contain" @touchmove.prevent>
    <div class="select">
      <div class="makesure">
        <div class="cancel" @click="cancel">取消</div>
        <div class="sure" @click="sure">确认</div>
      </div>
      <mt-picker :slots="slots" @change="onValuesChange"></mt-picker>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      slots: [
        {
          flex: 1,
          values: ['休闲娱乐场所', '商业中心', '沿街商铺', '写字楼、办公楼'],
          className: 'slot1',
          textAlign: 'center'
        }
      ],
      value: ''
    }
  },
  methods: {
    onValuesChange (picker, values) {
      this.value = values[0]
      console.log(values[0])
      if (values[0] > values[1]) {
        picker.setSlotValue(1, values[0])
      }
    },
    cancel () {
      this.$emit('site', false, '')
    },
    sure () {
      this.$emit('site', false, this.value)
    }
  }
}
</script>
<style  scoped>
.contain {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  overflow: hidden;
}
.select {
  width: 100%;
  height: 43px;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 210px;
  background: #fff;
}
.select > .makesure {
  width: 100%;
  height: 43px;
  line-height: 43px;
  background: #f9f9f9;
}

.cancel {
  float: left;
  height: 43px;
  line-height: 43px;
  width: 50px;
  text-align: center;
  font-size: 14px;
}
.sure {
  float: right;
  height: 43px;
  line-height: 43px;
  width: 65px;
  text-align: center;
  font-size: 14px;
  color: #dd2f21;
}
.picker {
  height: 180px;
  -webkit-overflow-scrolling: touch;
}
.picker .picker-slot-wrapper {
  -webkit-overflow-scrolling: touch;
}
</style>



// WEBPACK FOOTER //
// src/components/project_Site.vue